import type { ReactNode } from "react";


interface MetricTilesCardProps {
  children: ReactNode;
}

/** White bordered 2-column grid shell for MetricTile pairs. */
function MetricTilesCard({ children }: MetricTilesCardProps) {
  return (
    <div className="rounded-xl border border-brand bg-white p-xl">
      <div className="grid grid-cols-2 gap-md">
        {children}
      </div>
    </div>
  );
}

export default MetricTilesCard;
